import TableWrapper from "../../../../Components/Common/Tables/Tanstack/components/TableWrapper";
import CommonHeader from "../../../../Components/Common/CommonHeader/CommonHeader";
import { useDispatch, useSelector } from "react-redux";
import useSelectedOrgMappingColumns from "../Hooks/useSelectedOrgMappingColumns";
import { orgMappingData } from "../Json/OrganizationJson";
import { getOrgId, getOrganizationId } from "../../../../Utils/CommonUtils";
import { useEffect } from "react";
import { getOrgRelationshipListing } from "../OrganizationService";

const OrgMapping = () => {
  const dispatch = useDispatch();
  const data = useSelector(
    (state) => state.organization.selectedOrganization.detailsData
  );

  const triggerRender = useSelector((state) => state.common.triggerRender);
  const orgMappingData = useSelector(
    (state) => state.organization.selectedOrganization.orgMappingData
  );
  const { orgMappingColumns } = useSelectedOrgMappingColumns();
  const totalRows = orgMappingData ? orgMappingData.length : 0;
  const selectedUser = useSelector((state) => state.header.selectedUser);
  const organizationId = selectedUser.organizationid;

  useEffect(() => {
    if (organizationId) {
      getOrgRelationshipListing(data.organizationId, organizationId);
    }
  }, [organizationId]);

  return (
    <div>
      <CommonHeader
      // filterComponent={<UserFilter />}
      // selectComponent={
      //   <SelectDropdownAgMapping selectedRows={selectedRows} />
      // }
      // dash={true}
      />
      <div className="drill-table-mapping">
        <TableWrapper
          columns={orgMappingColumns}
          data={orgMappingData}
          // apiTabData={apiTabData}
          // paginatedApi
          // filterApi
          // filterApiEntity={"USR"}
          // filterApiListEntity={"USR"}
          // filterApiFunction={setUsersData}
          // filterApiService={getListingByOrgId}
          // filterForm={filterForm}
          totalRows={totalRows}
          // status={id}
          // statusColumn={"status"}
          // download
          // handleDownload={handleDownload}
          // hideTabs
          // hideTabsWrapper={true}
        />
      </div>
    </div>
  );
};

export default OrgMapping;
